if (!customElements.get('footer-details')) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        // if (!this.openDefault) this.open = false; disabled this
        if (!this.openDefault) this.open = true;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          // this.open = false; disabled this in 10.11.2025
          this.open = true;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, {
    extends: 'details',
  });
}
